import { ReactNode, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import { generateURL } from '@components/optimized-image/utils/generate-url';
import { Event } from '@domain/event';
import { GET_EVENT_QUERY_KEY, getEventByIdFetch } from '@hooks/events/use-get-event';

import { queryClient } from '../query-client';

const preloadImage = (url: string) => {
  const id = 'lcp-preload';
  const existing = document.getElementById(id) as HTMLLinkElement | null;
  if (existing) {
    if (existing.href !== url) existing.href = url;
    return;
  }
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'preload';
  link.as = 'image';
  link.href = url;
  document.head.appendChild(link);
};

const buildCoverImageUrl = (coverUrl: string, aspectRatio?: string) =>
  generateURL({
    src: coverUrl,
    alt: '',
    width: 480,
    format: 'auto',
    quality: 60,
    aspectRatio: aspectRatio === 'square' ? '1:1' : '16:9',
  });

export const ReportRouteWrapper = ({ children }: { children: ReactNode }) => {
  const { eventId } = useParams<{ eventId: string }>();

  useLayoutEffect(() => {
    if (eventId) {
      queryClient
        .prefetchQuery({
          queryKey: [GET_EVENT_QUERY_KEY, eventId],
          queryFn: () => getEventByIdFetch(eventId),
          staleTime: 10 * 1000,
        })
        .then(() => {
          const event = queryClient.getQueryData<Event>([GET_EVENT_QUERY_KEY, eventId]);
          if (event?.coverUrl) {
            preloadImage(buildCoverImageUrl(event.coverUrl, event.coverAspectRatio));
          }
        });
    }
  }, [eventId]);

  return <>{children}</>;
};
